<template>
  <div>
    <alertaMensaje :snackbar="mostrarSnackbar" :mensajeAlertaData="mensajeAlerta" @update-snackbar="hideSnackbar">
    </alertaMensaje>
    <v-container>
      <v-row v-if="verFormulario">
        <v-col cols="12" align-self="center">
          <ButtonComp @click="regresarComp()" textButton="Volver" classColor="red" normalButton
            iconBut="fas fa-arrow-alt-circle-left" />
        </v-col>
        <v-col cols="12">
          <v-row class="d-flex justify-center">
            <v-col cols="6" md="3">
              <v-text-field dense readonly v-model="parametros.items.item.desc_nivel" label="NIVEL"
                type="text"></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field dense prepend-icon="mdi-arrow-right-bold" readonly
                v-model="parametros.items.item.desc_grado" label="GRADO" type="text"></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field dense prepend-icon="mdi-arrow-right-bold" readonly v-model="parametros.items.item.desc_area"
                label="ÁREA" type="text"></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field dense prepend-icon="mdi-arrow-right-bold" readonly
                v-model="parametros.items.item.desc_curso" label="CURSO" type="text"></v-text-field>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <div>
            <v-container fluid>
              <v-row>
                <v-col cols="6" class=" ">
                  <!-- <label class="ml-2 grey--text">Dificultad:</label> -->
                  <v-radio-group v-model="dificultadCheckbox" label="Dificultad" class="mt-0" hide-details>
                    <div class="d-flex ">
                      <v-radio color="green" value="0" class="mr-3">
                        <template v-slot:label>
                          <strong class="success--text">Baja</strong>
                        </template>
                      </v-radio>
                      <v-radio color="blue" value="1" class="mr-3">
                        <template v-slot:label>
                          <strong class="primary--text">Media</strong>
                        </template>
                      </v-radio>
                      <v-radio color="red" value="2" class="mr-3">
                        <template v-slot:label>
                          <strong class="error--text">Alta</strong>
                        </template>
                      </v-radio>
                      <v-radio class="d-none"></v-radio>

                    </div>
                  </v-radio-group>
                </v-col>

                <v-col cols="6" class="d-flex align-end">
                  <v-select v-model="tipo_pregunta" @change="cambiarTipoRespuesta(tipo_pregunta)"
                    :items="itemTiposPreguntas" label="Seleccionar tipo de pregunta" chips :hint="tipo_pregunta.text"
                    persistent-hint></v-select>
                </v-col>

                <v-col cols="12" class="py-0">
                  <v-alert border="left" dense color="primary" dark elevation="10">
                    <!-- <v-divider class="pt-3 mt-3"></v-divider> -->
                    <!-- <h2 class="pa-0">CREACIÓN DE PREGUNTAS Y RESPUESTAS</h2> -->
                    <div class="text-center pa-2">

                      Unidad:
                      <span style="font-weight: 300">
                        {{ parametros.items.item.nombre_tema }}
                      </span>

                      <br>
                      Tema:
                      <span style="font-weight: 300">
                        {{ parametros.items.item.nombre_clase }}
                      </span>
                    </div>
                    <!-- <h5>Implementa tus preguntas</h5> -->

                    <!-- <v-btn class="mx-2" fab dark x-small color="green-blue darken-4">
                        <v-icon dark> mdi-format-paint </v-icon>
                      </v-btn> -->
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <v-alert border="left" dense color="success" outlined dark elevation="10" class="text-center">
                    <h4>Formula tu pregunta</h4>
                    <div class="d-flex pb-1">
                      <v-spacer></v-spacer>
                      <v-btn @click="abrirTextareaPregunta" dark small color="orange">
                        <v-icon dark class="pr-1"> {{ doingPregunta ? " mdi-check" : "mdi-pencil" }} </v-icon>
                        {{ doingPregunta ? "Guardar pregunta" : "Editar pregunta" }}
                      </v-btn>

                    </div>
                  </v-alert>
                </v-col>
                <!-- autofocus -->
                <v-col cols="12" v-if="doingPregunta" class="py-0 my-0 text-center">
                  <!-- <v-textarea @keydown.enter.exact.prevent @keyup.enter.exact="agregaPreguntaVista"
                    @keydown.enter.shift.exact="nuevaLineaTxArea" @keyup="validaTextAreaPregunta"
                    prepend-icon="mdi-comment" v-model="textarea_pregunta" filled auto-grow label="* ESCRIBE TU PREGUNTA"
                    rows="3" row-height="20" shaped></v-textarea> -->

                  <!-- <v-sheet color="grey" class="" v-if="textarea_pregunta == ''">
                    <v-skeleton-loader class="mx-auto"
                      type="table-thead, table-row-divider@3, table-tfoot"></v-skeleton-loader>
                  </v-sheet> -->

                  <ckeditor class="classEditor" @input="validaTextAreaPregunta" tag-name="textarea"
                    v-model="textarea_pregunta" :config="editorConfig"></ckeditor>

                  <!-- <v-btn
                    class="mt-3"
                    @click="agregaPreguntaVista"
                    v-show="btnAgregaPregunta"
                    depressed
                    color="primary"
                    small
                  >
                    Agregar pregunta
                    <v-icon> mdi-plus </v-icon>
                  </v-btn> -->
                </v-col>
                <!-- <strong>¿</strong> {{ textarea_pregunta }}
                      <strong>?</strong> -->
                <v-col v-if="preguntaHecha" cols="12">
                  <div class="pa-4" style="background: #eaeaea; text-align: center">
                    <h2 v-html="textarea_pregunta"></h2>
                  </div>
                </v-col>

                <v-col cols="12" class="">
                  <div style="text-align: center">
                    <v-alert border="left" dense color="success" outlined dark elevation="10">
                      <div style="text-align: center">
                        <h4>Ingresa tu respuesta</h4>
                        <div class="d-flex pb-1">

                          <v-spacer></v-spacer>
                          <template v-if="doingRespuesta">
                            <v-btn @click="agregarRespuesta(textarea_respuesta)" dark small color="orange"
                              :disabled="rptaDisabled">
                              <v-icon dark class="pr-1">mdi mdi-plus</v-icon>
                              Guardar respuesta
                            </v-btn>

                          </template>
                          <template v-else>
                            <v-btn @click="abrirTextareaRespuesta" dark small color="success" :disabled="rptaDisabled">
                              <v-icon dark class="pr-1">mdi-pencil</v-icon>
                              Escribir respuesta
                            </v-btn>

                          </template>



                          <!--                         
                        <v-btn
                          @click="abrirTextareaRespuesta"
                          :disabled="rptaDisabled"
                          class="mx-2"
                          fab
                          dark
                          x-small
                          color="success"
                        >
                          <v-icon dark>
                            {{ doingRespuesta ? " mdi mdi-plus" : "mdi-pencil" }}
                          </v-icon>
                            {{ doingRespuesta ? "" : "mdi-pencil" }}
                        </v-btn> -->
                        </div>

                        <!-- <v-btn class="mx-2" fab dark x-small color="light-blue darken-4">
                          <v-icon dark> mdi-format-paint </v-icon>
                        </v-btn> -->
                      </div>
                    </v-alert>
                  </div>
                </v-col>
                <!-- autofocus -->
                <v-col cols="12" v-if="doingRespuesta" class="py-0 my-0 text-center">
                  <v-textarea @keydown.enter.exact.prevent @keyup.enter.exact="agregarRespuesta(textarea_respuesta)"
                    @keydown.enter.shift.exact="nuevaLineaTxArea" @keyup="validaTextAreaRespuesta" ref="textareaResp"
                    prepend-icon="mdi-comment" color="green darken-3" v-model="textarea_respuesta" filled auto-grow
                    label="* ESCRIBE UNA RESPUESTA" rows="3" row-height="20" shaped
                    :disabled="rptaDisabled"></v-textarea>
                  <!-- <v-btn
                    v-show="btnAgregaRespuesta"
                    @click="agregarRespuesta(textarea_respuesta)"
                    depressed
                    color="primary"
                    small
                  >
                    {{ tituloBotonAgregaEdita }}
                    <v-icon> mdi-plus </v-icon>
                  </v-btn> -->
                </v-col>

                <v-col cols="12" class="py-0 text-center text-subtitle-1">
                  <div>
                    <span>Alternativas </span>
                    <span v-if="tipo_pregunta == 'res_uni'">
                      / Selección única
                    </span>
                    <span v-if="tipo_pregunta == 'res_mul'">
                      / Selección múltiple
                    </span>
                    <span v-if="tipo_pregunta == 'ver_fal'">
                      : Selección V / F
                    </span>
                  </div>
                </v-col>



                <v-col cols="12">
                  <!-- RESPUESTAS DINAMICAS LOOP O BLUCE FOREACH -->
                  <v-alert v-for="(respta, i) in coleccionRespuestas" :key="i" :type="coloresValidos[i] || 'error'"
                    prominent dense>
                    <v-row align="center">
                      <v-col class="grow">
                        {{ respta }}
                      </v-col>
                      <v-col class="shrink d-flex">
                        <!-- RESPUESTA UNICA -->
                        <div v-if="tipo_pregunta == 'res_uni'" class="mt-1 pt-1">
                          <v-radio-group class="mr-2 mt-2 pt-0" v-model="radioButtonRstpaUnica[i]"
                            @change="radioButtonCorrecto($event, i, true)">
                            <v-radio style="margin-top: -2px" :value="i">
                            </v-radio>
                          </v-radio-group>
                        </div>
                        <!-- RESPUESTA MULTIPLE -->
                        <div v-if="tipo_pregunta == 'res_mul'" class="mt-1 pt-1">
                          <!-- @click.native="checkBoxCorrecto" -->
                          <v-checkbox @change="checkBoxCorrecto($event, i)" v-model="checkboxesRespuestas[i]"
                            :ripple="true" style="margin: 2px 10px" hide-details></v-checkbox>
                        </div>
                        <!-- RESPUESTA V o F -->
                        <div v-if="tipo_pregunta == 'ver_fal'" class="mt-1 pt-1">
                          <v-radio-group class="mr-2 mt-2 pt-0" v-model="radioButtonRstpaUnica[i]"
                            @change="radioButtonCorrecto($event, i, true)">
                            <v-radio style="margin-top: -2px" :value="i">
                            </v-radio>
                          </v-radio-group>
                          <!-- <v-btn-toggle
                            style="margin-top: -2px"
                            v-model="vf_value[i]"
                            
                            group
                            @change="vf_change($event, i)"
                          >
                            <v-btn value="V"> <strong>V</strong> </v-btn>

                            <v-btn value="F"> <strong>F</strong> </v-btn>
                          </v-btn-toggle> -->
                        </div>

                        <v-btn @click="editarRespuesta(i)" class="ma-2"
                          :disabled="tipo_pregunta == 'ver_fal' ? true : false" text icon color="grey darken-4">
                          <v-icon> mdi-square-edit-outline</v-icon>
                        </v-btn>
                        <v-btn @click="eliminarRespuesta(i)" :disabled="tipo_pregunta == 'ver_fal' ? true : false"
                          class="ma-2" text icon color="grey darken-4">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>

        <!-- <v-btn @click="testmostrar" depressed color="warning" small>
          test
        </v-btn> -->

        <v-col cols="12" class="text-center" v-if="btnguardar">
          <ButtonComp :loading="loadingbtnGuardar" :disabled="loadingbtnGuardar" @click="guardarPreguntaDB"
            :textButton="btnguardarTitle" iconBut="fas fa-save" normalButton />
        </v-col>
      </v-row>
    </v-container>
    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModalF()">
    </component>
  </div>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';

// import { mapState, mapMutations } from "vuex";
export default {
  name: "formularioPregunta",
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  components: {
    alertaMensaje: () => import("../../SimuladorExamenes/components/Co-alertaMensaje.vue"),
    listaPreguntas: () => import("./listaPreguntas.vue"),
    ButtonComp
  },
  data: () => ({
    editorConfig: {

      toolbar: [
        ['ckeditor_wiris_formulaEditor', 'ckeditor_wiris_formulaEditorChemistry'],
        "Format",
        ["Bold", "Italic", "Strike", "Underline"],
        ["BulletedList", "NumberedList", "Blockquote"],
        ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"],
        ["Link", "Unlink"],
        ["FontSize", "TextColor"],
        ["Image"],
        ["Undo", "Redo"],
        ["Source", "Maximize"],
      ],
      extraPlugins: "language,font,image, ckeditor_wiris",
      height: "200",
      width: "95%",
      placeholder: "Escribe una pregunta",
      toolbarCanCollapse: true,
      allowedContent: true,
      // uiColor: "#01579b",
      codeSnippet_theme: "pojoaque",
      filebrowserImageBrowseLinkUrl:
        "https://onedrive.live.com/?id=59FFBD6D7046F78D%21105&cid=59FFBD6D7046F78D",
      font_names:
        "Arial/Arial, Helvetica, sans-serif;" +
        "Times New Roman/Times New Roman, Times, serif;" +
        "Verdana",

      codeSnippet_languages: {
        javascript: "JavaScript",
        php: "PHP",
      },
    },

    alertRespuestas: "",
    btnguardar: false,
    snackbarAlerta: false,
    Alertatext: "",
    timeout: 2000,

    rptaDisabled: false,
    // objetoReplicaTemas: [],
    idtema: "",
    select_nivel: "",
    select_grado: "",
    select_area: "",
    select_curso: "",

    loadingbtnGuardar: false,
    btnguardarTitle: "Guardar",
    idpreguntaValida: null,
    itemTiposPreguntas: [
      { text: "Respuesta única", value: "res_uni" },
      { text: "Respuesta múltiple", value: "res_mul" },
      { text: "Verdadero o falso", value: "ver_fal" },
    ],

    radioButtonRstpaUnica: [],
    // Variables de alerta
    mostrarSnackbar: false,
    mensajeAlerta: "",

    // Variable de AlertConfim
    mostrarDialogConfirm: false,
    validaDialogConfirm: false,
    mensajeDialog: "",

    // radioButtonRstpaUnica: null,
    vf_value: [],

    totalPag: null,
    snackbarOrden: false,
    colorsnackbarOrden: "green",
    textAlertOrden: "",

    doingPregunta: false,
    preguntaHecha: false,
    btnAgregaPregunta: false,
    btnAgregaRespuesta: false,

    respuestaHecha: false,
    textarea_respuesta: "",
    idrespuestaIndex: "",
    doingRespuesta: false,
    tituloBotonAgregaEdita: "Agrega respuestas",
    estadoAgregaEdita: 0, //0 agrega 1 edita

    tipo_pregunta: "res_uni",
    textarea_pregunta: "",
    textarea_pregunta2: "",
    dificultadCheckbox: "0",
    idclase: null,
    coleccionRespuestas: [],

    arrayPreguntasYrespuestas: [],
    arrayRespuestasPorPreguntas: [],
    arrayBalotarioDeleted: [], //Array de id Balotario
    arrayPreguntaDeleted: [], //Array de id Preguntas
    objetoDetalleRespuesta: [],
    coloresValidos: [],
    checkboxesRespuestas: [],
    color: "error",
    datoLogin: sessionStorage,

    compName: null,
    estadoComponente: null,
    parametroComp: [],
    verFormulario: true,
    objeto: {}
  }),
  mounted() {
    this.init();
  },
  watch: {

    estadoComp() {
      if (this.estadoComp) {
        this.init();
      } else {
        this.verFormulario = false;
      }
    },
    coleccionRespuestas(e) {
      if (e.length != 0) {
        this.btnguardar = true;
      } else {
        this.btnguardar = false;
      }
    },
  },
  methods: {
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    async init() {
      const me = this;
      me.verFormulario = true;
      console.log(this.parametros);

      if (me.parametros.event == "view_gestor") {
        me.limpiarPreguntas();
      } else {
        me.btnguardar = true;
        me.btnguardarTitle = "Editar";
        me.preguntaHecha = true;
        me.doingPregunta = false;
        me.textarea_pregunta = this.parametros.item.titulo;
        me.textarea_pregunta2 = this.parametros.item.titulo;
        me.ordenPregunta = this.parametros.item.orden;
        me.idpreguntaValida = this.parametros.item.idpregunta;
        me.tipo_pregunta = this.parametros.item.tipo;
        me.doingRespuesta = false;
        switch (this.parametros.item.tipo) {
          case "ver_fal":
            me.doingRespuesta = false;
            me.rptaDisabled = true;
            break;

          case "res_uni":
            me.doingRespuesta = true;
            me.rptaDisabled = false;
            break;

          case "res_mul":
            me.doingRespuesta = true;
            me.rptaDisabled = false;
            break;
        }

        me.dificultadCheckbox = this.parametros.item.dificultad.toString();
        await me.listarRespuestaPorPregunta(this.parametros.item);
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    hideSnackbar(e) {
      this.mostrarSnackbar = e;
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    abrirTextareaPregunta() {
      const me = this;

      if (me.doingPregunta && me.textarea_pregunta == "") {
        alert("Por favor redacte una pregunta.")
        return
      }

      me.doingPregunta = !me.doingPregunta;
      if (me.doingPregunta == true) {
        me.preguntaHecha = false;

        setTimeout(() => {
          this.textarea_pregunta = this.textarea_pregunta2;
        }, 1000);
      } else {
        this.textarea_pregunta2 = this.textarea_pregunta
        me.preguntaHecha = true;
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    abrirTextareaRespuesta() {
      const me = this;

      if (!me.preguntaHecha) {
        me.snackbarOrden = true;
        me.colorsnackbarOrden = "red";
        me.textAlertOrden = "Ingresa una Pregunta previamente";

        return false;
      }

      me.doingRespuesta = !me.doingRespuesta;

      if (me.doingRespuesta == true) {
        me.respuestaHecha = false;
      } else {
        me.respuestaHecha = true;
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    agregarRespuesta(rpsta) {
      const me = this;

      if (me.textarea_respuesta != "") {
        me.textarea_respuesta = "";
        me.respuestaHecha = true;
        me.$refs.textareaResp.focus();

        if (me.estadoAgregaEdita == 1) {
          //CUANDO EDITA O ACTUALIZA RESPUESTAS

          me.coleccionRespuestas[me.idrespuestaIndex] = rpsta;
          me.objetoDetalleRespuesta[me.idrespuestaIndex].descripcion = rpsta; //Nuevo Valor en Objeto a Editar
          me.estadoAgregaEdita = 0;
          me.tituloBotonAgregaEdita = "Agrega respuesta";
          // me.btnAgregaRespuesta();
          // me.$refs.textareaResp.select();
        } else {
          //CUANDO REGISTRA O CREA RESPUESTAS

          const idpregunta =
            me.idpreguntaValida == "" && me.idpreguntaValida == null
              ? ""
              : me.idpreguntaValida;

          console.log(idpregunta);

          const objtCrea = {
            valor_respuesta: false,
            descripcion: rpsta,
            orden: 0,
            idpregunta: idpregunta,
            estado: true,
          };
          me.objetoDetalleRespuesta.push(objtCrea);
          me.coleccionRespuestas.push(rpsta);
        }

        // me.hideBotones();
      } else {
        alert("Escribe una respuesta");
        return false;
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    editarRespuesta(i) {
      const me = this;
      me.idrespuestaIndex = i;
      me.tituloBotonAgregaEdita = "Edita respuesta";
      me.estadoAgregaEdita = 1;
      me.textarea_respuesta = me.coleccionRespuestas[i]; //+ 'indice '+ i
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    eliminarRespuesta(i) {
      const me = this;
      console.log(me.radioButtonRstpaUnica);
      console.log(me.coloresValidos);
      me.coleccionRespuestas.splice(i, 1);
      me.objetoDetalleRespuesta.splice(i, 1);
      me.coloresValidos.splice(i, 1);
      // CHECKBOX UNICO, MULTIPLE, VERDADERO Y FALSO.
      me.vf_value.splice(i, 1);
      me.checkboxesRespuestas.splice(i, 1);
      me.radioButtonRstpaUnica.splice(i, 1);
      // me.radioButtonRstpaUnica[i] = i;

      let indexFind = me.coloresValidos.indexOf("success");
      me.radioButtonRstpaUnica[indexFind] = indexFind;

      console.log(indexFind);

      // me.hideBotones();
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    validaTextAreaPregunta() {
      const me = this;
      if (me.textarea_pregunta == "") {
        me.btnAgregaPregunta = false;
      } else {
        me.btnAgregaPregunta = true;
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    validaTextAreaRespuesta() {
      const me = this;
      if (me.textarea_respuesta == "") {
        me.btnAgregaRespuesta = false;
      } else {
        me.btnAgregaRespuesta = true;
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    cambiarTipoRespuesta(valor) {
      const me = this;

      me.radioButtonRstpaUnica = [];
      me.coleccionRespuestas = [];
      me.objetoDetalleRespuesta = [];
      me.doingRespuesta = true;

      console.log(valor);
      me.coloresValidos = [];
      me.checkboxesRespuestas = [];
      me.vf_value = [];

      if (valor == "ver_fal") {
        me.doingRespuesta = false;
        me.rptaDisabled = true;

        let VerdaderFalso = ["VERDADERO", "FALSO"];

        const idpregunta =
          me.idpreguntaValida == "" && me.idpreguntaValida == null
            ? ""
            : me.idpreguntaValida;

        for (let i = 0; i < VerdaderFalso.length; i++) {
          me.objetoDetalleRespuesta.push({
            valor_respuesta: false,
            descripcion: VerdaderFalso[i],
            orden: 0,
            idpregunta: idpregunta,
            estado: true,
          });

          me.coleccionRespuestas.push(VerdaderFalso[i]);
        }
      } else {
        me.coleccionRespuestas = [];
        me.rptaDisabled = false;
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    radioButtonCorrecto(checked, i, flag) {
      const me = this;
      me.radioButtonRstpaUnica = [];
      me.radioButtonRstpaUnica[i] = checked;

      me.objetoDetalleRespuesta[i].valor_respuesta = [];
      for (let o = 0; o < me.objetoDetalleRespuesta.length; o++) {
        if (i == o) {
          me.objetoDetalleRespuesta[o].valor_respuesta = flag;
        } else {
          me.objetoDetalleRespuesta[o].valor_respuesta = false;
        }
      }

      me.coloresValidos = [];
      me.coloresValidos[checked] = "success";
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    checkBoxCorrecto(checked, i) {
      const me = this;

      console.log(me.objetoDetalleRespuesta[i].valor_respuesta);
      console.log(i);

      if (checked) {
        me.coloresValidos[i] = "success";
        me.objetoDetalleRespuesta[i].valor_respuesta = true;
      } else {
        me.coloresValidos[i] = "error";
        me.objetoDetalleRespuesta[i].valor_respuesta = false;
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    async guardarPreguntaDB() {
      const me = this;

      // const hasTrueValue = me.objetoDetalleRespuesta.some(
      //   (obj) => Object.values(obj)[0] === true
      // );

      // if (!hasTrueValue) {
      //   alert("Por favor Selecciona una respuesta");
      //   return false;
      // }

      if (me.doingPregunta == true) {
        alert("Por favor agrega la pregunta");
        return false;
      }

      // CREAR PREGUNTA Y RESPUETAS
      if (me.idpreguntaValida == "" || me.idpreguntaValida == null) {
        try {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();
          me.loadingbtnGuardar = true;
          const respuesta = await axios.post(
            "/simulador/simuladorExamenColegio/simuladorAdmPreguntas/simuladorAdmP/registraAdm",
            {
              descripcion_balotario:
                "BALOTARIO" + me.parametros.items.item.id,
              descripcion: me.textarea_pregunta,
              tipo_pregunta: me.tipo_pregunta,
              orden: me.parametros.cantidad.length + 1,
              nivel: me.dificultadCheckbox,
              idtema: me.parametros.items.item.id,
              respuestas: me.objetoDetalleRespuesta,
              id_colegio: this.datoLogin.id_colegio
            }
          );
          if (respuesta.status == "200") {
            NProgress.done();
            me.loadingbtnGuardar = false;
            me.btnAgregaPregunta = false;
            me.btnguardar = false;
            me.mostrarSnackbar = true;
            me.mensajeAlerta = "Pregunta registrada satisfactoriamente";
            me.idpreguntaValida == "";
          }
          me.limpiarPreguntas();
          me.$emit("close");
        } catch (error) {
          console.log(error);
        }
        // EDITAR PREGUNTA Y RESPUETAS
      } else {
        try {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();
          me.loadingbtnGuardar = true;
          const respuesta = await axios.put(
            "/simulador/simuladorExamenColegio/simuladorAdmPreguntas/simuladorAdmP/actualizaAdm/" +
            me.idpreguntaValida,
            {
              descripcion_balotario: "BALOTARIO" + me.parametros.item.idclase,
              descripcion: me.textarea_pregunta,
              tipo_pregunta: me.tipo_pregunta,
              orden: me.ordenPregunta,
              nivel: me.dificultadCheckbox,
              idtema: me.parametros.item.idclase,
              respuestas: me.objetoDetalleRespuesta,
              id_colegio: this.datoLogin.id_colegio
            }
          );

          console.log(me.objetoDetalleRespuesta);
          console.log(respuesta);

          if (respuesta.status == "200") {
            NProgress.done();
            me.loadingbtnGuardar = false;
            me.btnAgregaPregunta = false;
            me.btnguardar = false;
            me.mostrarSnackbar = true;
            me.mensajeAlerta = "Pregunta actualizada satisfactoriamente";
            me.idpreguntaValida == "";
          }
          me.limpiarPreguntas();
          me.$emit("close");
        } catch (error) {
          console.log(error);
        }
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    agregaPreguntaVista() {
      const me = this;
      me.doingPregunta = false;
      me.preguntaHecha = true;
      me.doingRespuesta = true;
      // me.$refs.textareaResp.focus();
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    CloseModalF() {
      const me = this;
      me.estadoComponente = false;
      me.verFormulario = false;
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    limpiarPreguntas() {
      const me = this;
      me.idpreguntaValida = "";
      me.tipo_pregunta = "res_uni";
      me.textarea_pregunta = "";
      me.dificultadCheckbox = "0";
      me.idclase = null;
      me.coleccionRespuestas = [];
      me.objetoDetalleRespuesta = [];
      me.coloresValidos = [];
      me.checkboxesRespuestas = [];
      me.radioButtonRstpaUnica = [];
      me.vf_value = [];
      me.doingPregunta = true;
      me.preguntaHecha = false;
      me.btnAgregaPregunta = false;
      me.btnAgregaRespuesta = false;
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    async listarRespuestaPorPregunta(items) {
      const me = this;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      try {
        const response = await axios.get(
          "/simulador/simuladorExamenColegio/simuladorAdmRespuestas/simuladorAdmR/listarespregAdm/" +
          items.idpregunta
        );
        me.textarea_respuesta = "";
        me.arrayRespuestasPorPreguntas = response.data;
        console.log(items.tema);

        setTimeout(async () => {
          NProgress.done();
        }, 800);

        me.arrayRespuestasPorPreguntas.forEach((element, index) => {
          me.coleccionRespuestas.push(element.respuesta);
          const objtEdita = {
            idrespuesta: element.idrespuesta,
            valor_respuesta: element.valor_respuesta,
            descripcion: element.respuesta,
            orden: 0,
            idpregunta: items.idpregunta,
            estado: true,
          };
          me.objetoDetalleRespuesta.push(objtEdita);

          switch (items.tipo) {
            case "res_uni":
              if (objtEdita.valor_respuesta) {
                me.radioButtonRstpaUnica[index] = index;
                me.coloresValidos[index] = "success";
              }
              break;

            case "res_mul":
              if (objtEdita.valor_respuesta) {
                me.checkboxesRespuestas[index] = objtEdita.valor_respuesta;
                me.coloresValidos[index] = "success";
              }

              break;

            case "ver_fal":
              if (objtEdita.valor_respuesta) {
                me.radioButtonRstpaUnica[index] = index;
                me.coloresValidos[index] = "success";
              }
              break;

            default:
              break;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    /*-----------------------------------------
    | LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    regresarComp() {
      this.objeto = {};
      this.limpiarPreguntas();
      this.$emit('close')
    },

  },

};
</script>

<style>
.cke_button__ckeditor_wiris_formulaeditor .cke_button_icon {
  background-image: url('/ckeditor/icons/formula.png') !important;

}

.cke_button__ckeditor_wiris_formulaeditorchemistry .cke_button_icon {
  background-image: url('/ckeditor/icons/chem.png') !important;
}


.classEditor {
  display: flex;
  justify-content: space-around;
}

#editor:empty::before {
  content: "Escribe tu texto aquí...";
  color: #888;
  /* Color de texto gris */
  position: absolute;
  pointer-events: none;
  /* Evitar que el marcador de posición sea interactivo */
}
</style>
